import { render, staticRenderFns } from "./formBase.vue?vue&type=template&id=2644942a&"
import script from "./formBase.vue?vue&type=script&lang=ts&"
export * from "./formBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports